import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getEmployeeSelector = createSelector(
  employee => employee.employee,
  (employeeById) => getArrayOfObjectValues(employeeById)
);